import * as types from '../../actions/actionTypes';

const defaultState = {
  sponsors: {},
  imageUploadedUrl: '',
};

export default (state = defaultState, action) => {
  const nextState = Object.assign({}, state);

  switch (action.type) {
    case types.FETCH_CODEBASES:
      return { ...state, sponsors: {} };
    case types.GET_CODEBASE_SPONSORS_SUCCESS:
      return { ...state, sponsors: action.data };
    case types.UPLOAD_SPONSOR_IMAGE_SUCCESS:
      return { ...state, imageUploadedUrl: action.data, uploadStep: 'SUCCESS' };
    case types.UPLOAD_SPONSOR_IMAGE:
      return { ...state, uploadStep: 'UPLOADING' };
    case types.UPLOAD_SPONSOR_IMAGE_FAILED:
      return { ...state, uploadStep: 'FAILED' };
    case types.UPDATE_CODEBASE_SPONSOR_SUCCESS:
      return { ...state, sponsors: { ...state.sponsors, [action.data._id]: action.data }, imageUploadedUrl: '' };
    default:
      return nextState;
  }
};
